import React from 'react';
import { Container, HeaderContainer } from './PrimeHeader.style';

interface PrimeHeaderProps {
  agent?: boolean;
}

const PrimeHeader: React.FC<PrimeHeaderProps> = ({ agent }) => {
  if (agent) {
    return (
      <Container data-testid="prime-header">
        <HeaderContainer>
          <h1>Put Your Listing in a Prime Position</h1>
          <p className="prime-subheader">
            Prime is designed to give properties more visibility while boosting agent exposure.
          </p>
        </HeaderContainer>
      </Container>
    );
  }

  return (
    <Container data-testid="prime-header">
      <HeaderContainer>
        <h1>Properties with Prime get</h1>
        <h2>up to 80% more enquiries</h2>
        <p className="prime-subheader">
          Choose the level of visibility that puts your property in front of more buyers &amp; renters.
        </p>
      </HeaderContainer>
    </Container>
  );
};

export default PrimeHeader;
